var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467,225H319V46c0-24.8-20.2-45-45-45H45C20.2,1,0,21.2,0,46v420c0,24.8,20.2,45,45,45h229 c24.8,0,45-20.2,45-45v-19h148c24.8,0,45-20.2,45-45V270C512,245.2,491.8,225,467,225z M467,255c8.3,0,15,6.7,15,15v19H319v-34 H467z M289,466c0,8.3-6.7,15-15,15H45c-8.3,0-15-6.7-15-15V46c0-8.3,6.7-15,15-15h229c8.3,0,15,6.7,15,15V466z M467,417H319v-98 h163v83C482,410.3,475.3,417,467,417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,285.1c-1.9-9-10.7-13.9-19.1-11.4c-8.5,2.8-12.2,11.2-10,18.7c2.8,8.6,11.3,12.2,18.7,10 C108.2,299.8,112.1,292.4,110.7,285.1L110.7,285.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,275.5c-11.1-7.3-25.5,2.2-23,15.4c2.6,12.3,18,16.4,26.3,6.6C177.4,290.2,175.4,280.3,168.3,275.5 L168.3,275.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.7,285.1c-1.9-9-10.9-13.9-19.1-11.4c-8.4,2.7-12.3,11.1-10,18.7c2.8,8.5,11.2,12.2,18.7,10 C236.2,299.8,240.1,292.4,238.7,285.1L238.7,285.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,349.1c-1.9-8.9-10.7-13.9-19.1-11.4c-8.5,2.8-12.2,11.2-10,18.7c2.8,8.6,11.3,12.2,18.7,10 C108.2,363.9,112.1,356.4,110.7,349.1L110.7,349.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,339.5c-11.1-7.3-25.5,2.2-23,15.4c2.6,12.3,18,16.4,26.3,6.6C177.4,354.2,175.5,344.4,168.3,339.5 L168.3,339.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.7,349.1c-1.9-9-10.8-13.9-19.1-11.4c-8.6,2.7-12.2,11.4-10,18.7c2.7,8.4,11.1,12.3,18.7,10 C236.2,363.8,240.1,356.4,238.7,349.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,413.1c-1.9-8.9-10.7-13.9-19.1-11.4c-8.6,2.8-12.2,11.3-10,18.7c2.8,8.6,11.4,12.2,18.7,10 C108.1,427.9,112.1,420.5,110.7,413.1L110.7,413.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.3,403.5c-7.5-4.9-17.3-2.4-21.6,5.4c-5.9,11.5,3.8,24.1,16.2,21.8C176.1,428,179.3,411,168.3,403.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.7,413.1c-1.9-9-10.8-13.9-19.1-11.4c-8.3,2.6-12.3,11-10,18.7c2.8,8.6,11.2,12.2,18.7,10 C236.1,427.8,240.1,420.5,238.7,413.1L238.7,413.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240,65H80c-8.3,0-15,6.7-15,15v128c0,8.3,6.7,15,15,15h160c8.3,0,15-6.7,15-15V80C255,71.7,248.3,65,240,65z  M225,193H95V95h130V193z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.102c246bd64c2e46463e3ac88d01ea54.svg";
export { ForwardRef as ReactComponent };